import React, { Component } from 'react';
import { Utils } from '../../utils/utils';
import Sdk from 'api.digitalpages.module.sdk.api';
import './archive-categories.css';

export default class ArchiveCategories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "categories": null,
    };
  }

  componentWillMount() {
    this.getArchiveCategories();
  }

  componentDidMount() {

  }

  async getArchiveCategories() {
    var schema = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/available?type=category`);
    var category = schema.find(cat => cat.name === "Categorias");
    var categories = await Utils.bridgeAndStore(`/auth/v1.1/entity/schema/uid/${category.uid}/items/tree`);

    this.setState({
      "categories": categories
    })
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    var _this = this;
    const { categories } = this.state;

    return (
      <div className="archive-categories">
        <div className="archive-categories-header">
          <div className="archive-categories-header-left">
            <span className="archive-categories-header-title">Explore todo o acervo</span>
          </div>
        </div>
        <div className="archive-categories-content">
          <ul>
            {categories && categories.map(function (category, index) {
              return <li
                className={`archive-categories-card`}
                key={category.uid}
                onClick={() => _this.redirectTo(`/search/category/${category.uid}/1`)}
                style={{backgroundColor: category.data.Cor}}
              >
                {category.name}
              </li>
            })}
          </ul>
        </div>

      </div>
    );
  }
}
